import axios from 'axios'

export const refreshPageMixin = {
  data() {
    return {
      debug: false,
      intervalHolder: null,
      currentHash: null,
      newHash: null,
      hashChanged: false,
      checking: false
    }
  },

  async mounted() {
    if (this.debug || !import.meta.env.DEV) {
      await this.loadCurrentHash()
      this.intervalHolder = this.initVersionCheck('/version.json')
    }
  },
  unmounted() {
    this.clearInterval()
  },

  methods: {
    async loadCurrentHash() {
      try {
        const res = await axios.get('/version.json?t=' + Date.now())
        this.currentHash = res.data?.hash ?? null
      } catch (e) {}
    },
    clearInterval() {
      if (this.intervalHolder) {
        clearInterval(this.intervalHolder)
        this.intervalHolder = null
      }
    },
    initVersionCheck(url, frequency = 1000 * (this.debug ? 10 : 300)) {
      this.clearInterval()
      return setInterval(() => {
        if (!this.checking) this.checkVersion(url)
      }, frequency)
    },
    async checkVersion(url) {
      this.checking = true
      try {
        const res = await axios.get(url + '?t=' + Date.now(), { timeout: 3000 })
        this.newHash = res.data?.hash ?? null

        // si on n’a pas de currentHash (premier load offline), on ne force pas un reload
        if (!this.currentHash || !this.newHash) return

        this.hashChanged = this.currentHash !== this.newHash

        if (this.hashChanged && this.$route?.name === 'screen-view') {
          setTimeout(() => this.reloadApp(), 30 * 1000)
        }
      } catch (e) {
        if (this.debug) console.warn('Version check failed:', e?.message ?? e)
      } finally {
        this.checking = false
      }
    },
    reloadApp() {
      window.location.reload()
    }
  }
}
